import { makeBasicQueryKeys } from '@eigtech/ui-shared-api'
import { OwnerCorn } from '@eigtech/white-label-types'

export const whiteLabelBasePath = 'white-label'

export const whiteLabelQueryKeys = {
  ...makeBasicQueryKeys<OwnerCorn>('white-label'),
  defaultOwner: () => [...whiteLabelQueryKeys.all(), 'default-owner'],
  defaultOwnerInfo: () => [...whiteLabelQueryKeys.defaultOwner(), 'info'],
}
